import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

interface PricingCarouselButtonsProps {
  onPrev: () => void;
  onNext: () => void;
  disablePrev: boolean;
  disableNext: boolean;
  children?: React.ReactNode;
}

const PricingCarouselButtons = ({
  onPrev,
  onNext,
  disablePrev,
  disableNext,
  children,
}: PricingCarouselButtonsProps) => {
  return (
    <div className="relative flex items-center max-md:mt-4">
      <button
        className="btn btn-circle -ml-20 md:absolute md:left-0 md:-ml-14 lg:hidden"
        onClick={onPrev}
        disabled={disablePrev}
      >
        <FontAwesomeIcon icon={faChevronLeft} className="h-5 w-5 text-primary" />
      </button>
      {children}
      <button className="btn btn-circle ml-14 md:ml-2 lg:hidden" onClick={onNext} disabled={disableNext}>
        <FontAwesomeIcon icon={faChevronRight} className="h-5 w-5 text-primary" />
      </button>
    </div>
  );
};

export default PricingCarouselButtons;
